import classNames from "classnames";
import { forwardRef, useId, useRef } from "react";
import { InputAttributes, NumberFormatValues, NumericFormat, NumericFormatProps } from "react-number-format";
import inputStyles from "./Input.module.css";

export type Props = Omit<NumericFormatProps<InputAttributes>, "onChange" | "onValueChange" | "onBlur"> & {
  isInvalid?: boolean;
  min?: number;
  width?: `${number}px`;
  onBlur?: (value: number | null) => void;
  // onValueChange?: (value?: number) => void;
};

const Numeric = forwardRef<HTMLInputElement, Props>(({ isInvalid, min, width, ...rest }, ref) => {
  const formattedId = useId();
  const { autoComplete = "off", spellCheck = "false" } = rest;
  const id = rest.id || formattedId;

  /* 
    "lastChange" is saved at each "onValueChange" and triggered only at "onBlur",
    because when we have the scenario "0,something" and "something" is deleted, 
    the "," is deleted as well.

    - at each "onValueChange" the info are saved
    - once "onBlur" is triggered, the last info is returned
    
  */

  const lastChange = useRef<NumberFormatValues>(undefined);

  return (
    <div className={inputStyles.container}>
      <NumericFormat
        {...rest}
        id={id}
        value={rest.value === undefined || rest.value === null ? "" : rest.value} // needed in order to reset to empty
        disabled={rest.disabled}
        getInputRef={ref}
        thousandSeparator="."
        decimalSeparator=","
        autoComplete={autoComplete}
        spellCheck={spellCheck}
        onValueChange={(value) => {
          lastChange.current = value;
          // rest.onValueChange?.(lastChange.current.floatValue);
        }}
        onBlur={() => rest.onBlur?.(lastChange.current?.floatValue ?? null)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            rest.onBlur?.(lastChange.current?.floatValue ?? null);
          }
        }}
        onChange={() => {
          // needed in order to return a number instead a string
        }}
        style={{ width: width }}
        className={classNames(inputStyles.input, {
          [inputStyles.invalid]: isInvalid,
        })}
      />
    </div>
  );
});

export default Numeric;
